/** Época J2000.0 em data juliana. */
export const J2000_JD = 2451545.0;

/** Unidade astronômica em km (IAU). */
export const AU_KM = 149_597_870.7;

/** Velocidade da luz em km/s. */
export const SPEED_OF_LIGHT_KM_S = 299_792.458;

/** Constante gravitacional do Sol μ☉ em km³/s². */
export const SUN_MU_KM3_S2 = 1.32712440018e11;

/** Escala obrigatória: 1000 km reais = 1 mm no modelo. */
export const REAL_KM_PER_SCENE_MM = 1000;

/**
 * Conversão km → metros de cena (1 unidade Three.js = 1 m).
 * 1000 km → 1 mm → 0,001 m ⇒ fator 1e-6.
 */
export const KM_TO_SCENE_METERS = 1 / 1_000_000;

export const DEG_TO_RAD = Math.PI / 180;
export const RAD_TO_DEG = 180 / Math.PI;

export const SECONDS_PER_DAY = 86_400;
export const MS_PER_DAY = 86_400_000;
